/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPackageValues
 */
export interface SubscriptionPackageValues {
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackageValues
     */
    maxUsers?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackageValues
     */
    maxIntegrations?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackageValues
     */
    maxDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageValues
     */
    dataUpdatesPerDay?: number;
}

/**
 * Check if a given object implements the SubscriptionPackageValues interface.
 */
export function instanceOfSubscriptionPackageValues(value: object): value is SubscriptionPackageValues {
    return true;
}

export function SubscriptionPackageValuesFromJSON(json: any): SubscriptionPackageValues {
    return SubscriptionPackageValuesFromJSONTyped(json, false);
}

export function SubscriptionPackageValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackageValues {
    if (json == null) {
        return json;
    }
    return {
        
        'maxUsers': json['maxUsers'] == null ? undefined : json['maxUsers'],
        'maxIntegrations': json['maxIntegrations'] == null ? undefined : json['maxIntegrations'],
        'maxDomains': json['maxDomains'] == null ? undefined : json['maxDomains'],
        'dataUpdatesPerDay': json['dataUpdatesPerDay'] == null ? undefined : json['dataUpdatesPerDay'],
    };
}

export function SubscriptionPackageValuesToJSON(json: any): SubscriptionPackageValues {
    return SubscriptionPackageValuesToJSONTyped(json, false);
}

export function SubscriptionPackageValuesToJSONTyped(value?: SubscriptionPackageValues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxUsers': value['maxUsers'],
        'maxIntegrations': value['maxIntegrations'],
        'maxDomains': value['maxDomains'],
        'dataUpdatesPerDay': value['dataUpdatesPerDay'],
    };
}

